import { render, staticRenderFns } from "./TokensPriceChart.vue?vue&type=template&id=c022c50a&scoped=true"
import script from "./TokensPriceChart.vue?vue&type=script&lang=ts"
export * from "./TokensPriceChart.vue?vue&type=script&lang=ts"
import style0 from "./TokensPriceChart.vue?vue&type=style&index=0&id=c022c50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c022c50a",
  null
  
)

export default component.exports